export default  {
  // baseUrl:"http://api.ikshanagroup.com/api",
  baseUrl:"https://centofinapi.ctekholdings.in/backend/api",

  imageUrl:"https://centofinapi.ctekholdings.in/backend/uploads/",

    google: {
      API_KEY: "",
      CLIENT_ID: "23144678283-oek7ncjmmrgkgmi2i56sc411gp71a8sp.apps.googleusercontent.com",
      SECRET: "",
    },
    facebook: {
      APP_ID: "",
    },
    API_URL:''
  }